import { Pipe, PipeTransform } from '@angular/core';

export const DECORATIONS_TYPE = {
    badge: 'Badge',
    creep: 'Creep',
    wallGraffiti: 'Graffiti',
    wallLandscape: 'Wall texture',
    floorLandscape: 'Floor texture',
    landscape: 'Landscape',
    metadata: 'Skin',
    object: 'Object'
};

@Pipe({
    name: 'decorationType'
})
export class DecorationTypePipe implements PipeTransform {

    transform(type: string): string {
        return DECORATIONS_TYPE[type];
    }

}
